module.exports ={
    'special-effects': {
        h1: 'Special Effects',
     
        title: 'Special Effects | Miami Sound Rental',
        sub: ``,
        description:`Rent special effects for your event in Miami or Fort Lauderdale. Delivery and installation available.`
    },
    'visuals': {
        h1: 'Visuals',
        sub: ``,
        title: 'Visuals | Miami Sound Rental',
        description: 'Rent visual equipment for your next event in Miami or Fort Lauderdale. Video projectors and projector screens, LED video walls and TV rentals.',

    },
    'lighting': {
        h1: 'Lighting | Miami Sound Rental',
        sub: ``,
                description: 'Wedding and event lighting rentals in Miami and Fort Lauderdale. Rent uplights, monogram gobo projectors, UV lights, moving heads and other stage lighting.',
                title: 'Event Lighting & Uplight Rentals Miami',

    },
    'dj-equipment': {
        h1: 'DJ Equipment | Miami Sound Rental',
        title: 'DJ Equipment | Miami Sound Rental',
        description: 'CDJs and DJ equipment rentals in Miami and Fort Lauderdale. Rent Pioneer CDJ 2000, DJ mixers DJM 900, turntables and DJ booths.'
    },
    'sound': {
        h1: 'Audio Equipment and Microphone Rentals in Miami',
        title: 'Audio Equipment and Microphone Rentals in Miami',
        description: 'Rent your sound system and audio equipment with Miami sound rental. We provide speakers, subwoofers, line array, microphones and pro audio.'
    },
    'staging': {
        h1: 'Staging | Miami Sound Rental',
        title: 'Staging | Miami Sound Rental',
        description: 'Portable Stage and Truss rentals for your event or trade show booth. Create your own truss structure or pick one of our pre made options.'
    },

}